import axios from "axios";

const appauth_key = "Rahuwanshi@2029";
let APL_LINK = "http://192.168.1.17:8000";
APL_LINK = "https://api.raghuvanshihall.com";
let Website_URL = "https://www.raghuvanshihall.com/";
let Website_URL_admin_panel =
  "https://adminpanel.raghuvanshihall.com/adminlogin";
let local_server_link_react = APL_LINK + "/api/admin_link/";
let local_server_link_website = APL_LINK + "/api/website_link/";

/**Website Panel */
const get_all_website_data = local_server_link_react + "get_all_website_data/";
const save_subscribe = local_server_link_website + "save_subscribe/";
const get_all_booking_data =
  local_server_link_website + "get_all_booking_data/";
const save_enquiry_website =
  local_server_link_website + "save_enquiry_website/";
const get_all_home_front = local_server_link_website + "get_all_home_front/";
const get_all_home_gallery =
  local_server_link_website + "get_all_home_gallery/";
const seo_data_url = local_server_link_website + "get_seo_data/";
const get_seo_data_all = local_server_link_website + "get_seo_data_all/";
const get_blog_details_url =
  local_server_link_website + "get_blog_details_url/";
const get_all_home_about = local_server_link_website + "get_all_home_about/";
const get_all_faq_by_url = local_server_link_website + "get_all_faq_by_url/";
const get_all_blogs_with_seo =
  local_server_link_website + "get_all_blogs_with_seo/";
const save_update_contact = local_server_link_react + "save_update_contact/";
/**Website  panel */

// Retrieving data
const server_post_data = async (url_for, form_data) => {
  // const headers = {
  //   "Content-Type": "application/json",
  // };

  if (form_data === null) {
    form_data = new FormData();
  }

  form_data.append("appauth_key", appauth_key);
  form_data.append("res_name", "10099");
  return axios.post(url_for, form_data);
};

export {
  APL_LINK,
  Website_URL,
  appauth_key,
  server_post_data,
  /**Website  panel */
  save_subscribe,
  get_all_booking_data,
  save_enquiry_website,
  get_all_home_front,
  seo_data_url,
  get_all_home_gallery,
  get_all_home_about,
  get_blog_details_url,
  Website_URL_admin_panel,
  get_all_blogs_with_seo,
  get_all_website_data,
  get_seo_data_all,
  get_all_faq_by_url,
  save_update_contact,
  /**Website  panel */
};
